import React, { useEffect, useState } from 'react';
import SecureImage from './SecureImage';
import { IconButton, styled } from '@mui/material';
import * as ImageStore from 'store/Image';
import * as FolderStore from 'store/Folder';

import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MessageView from './MessageView';

const Root = styled('div')({
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'none',
    backgroundColor: '#666'
});

const CloseButton = styled(IconButton)({
    position: 'absolute',
    top: 16,
    right: 16
});

const ImageView = (props: { imageId?: string }) => {
    const root = React.createRef<HTMLDivElement>();
    const [width, setWidth] = useState<number>(840);
    const [height, setHeight] = useState<number>(840);
    const image = useSelector(ImageStore.selectors.byId(props.imageId || ''));
    const parentFolder = useSelector(FolderStore.selectors.byId(image ? image.folderId : ''));
    const navigate = useNavigate();

    useEffect(() => {
        if (root.current) {
            setWidth(root.current.clientWidth);
            setHeight(root.current.clientHeight);
        }
    }, [root]);

    const handleClose = () => {
        if (parentFolder) {
            navigate(`/folder/${parentFolder.id}`);
        }
    }

    if (!image) {
        return (<MessageView>Image with id {props.imageId} was not found</MessageView>);
    }

    return (
        <Root ref={root}>
            <CloseButton size="large" onClick={handleClose}>
                <CloseIcon />
            </CloseButton>
            <img src={`/api/image/${props.imageId}/data`} style={{ maxWidth: width - 32, maxHeight: height - 32 }} />
            {/* <SecureImage src={`/api/image/${props.imageId}/data`} style={{ maxWidth: width - 32, maxHeight: height - 32 }} /> */}
        </Root>
    )
}

export default ImageView;